import { Component, type ErrorInfo, type ReactNode } from 'react'
import { createLogger } from '@/utils'

interface ErrorBoundaryProps {
  children: ReactNode
  fallback: ReactNode
}

interface ErrorBoundaryState {
  hasCaughtError: boolean
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  private static readonly logger = createLogger('ErrorBoundary')

  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasCaughtError: false }
  }

  static getDerivedStateFromError(): Partial<ErrorBoundaryState> {
    return { hasCaughtError: true }
  }

  private logError = (err: Error, info: ErrorInfo): void => {
    ErrorBoundary.logger.error('Caught an error', { error: err, info })
  }

  componentDidCatch(err: Error, info: ErrorInfo): void {
    this.logError(err, info)
  }

  render() {
    const { hasCaughtError } = this.state
    const { fallback: fallbackUI, children } = this.props

    return hasCaughtError ? fallbackUI : children
  }
}
